import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { TareaRiegoModel } from '../../../../../models/tareas/tarea-riego.model';
import { MtoReactiveFormComponent } from '../../mto-reactive/mto-reactive-form.component';
import { TareasMtoRiegoFormDefinition } from './form-control/form-definition';

@Component({
    selector: 'app-tareas-mto-riego-form',
    standalone: false,
    templateUrl: './tareas-mto-riego-form.component.html',
    styleUrls: ['./tareas-mto-riego-form.component.scss'],
})
export class TareasMtoRiegoFormComponent extends MtoReactiveFormComponent<TareaRiegoModel, TareasMtoRiegoFormDefinition> {
    constructor(
        route: ActivatedRoute,
        dashboard: DashboardService,
        fincasApi: FincasApiService,
        clientesApi: ClientesApiService,
        trabajadoresApi: TrabajadoresApiService,
        tareasApi: TareasApiService,
        router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi,
            clientesApi,
            trabajadoresApi,
            tareasApi.mtoRiego.PUT,
            tareasApi.mtoRiego.POST,
            tareasApi.mtoRiego.GET,
            'riego',
            'Actualizar Tarea Riego',
            'Realizar Tarea Riego',
            'Duplicar Tarea Riego',
            {
                loadingLabel: 'Cargando datos del formulario de riego...',
                errorContext: 'riego',
                locationCascadeFields: ['id_finca', 'id_sector', 'ids_parcelas'],
            },
        );
    }

    protected createFormDefinition(): TareasMtoRiegoFormDefinition {
        return new TareasMtoRiegoFormDefinition(this.getType(), this.model);
    }
}
